import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import styles from './CustomerCard.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import AddContact from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/AddContact/AddContact'
import TagManagement from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/TagManagement/TagManagement'
import BackButton from 'components/CRM/UI/components/BackButton/BackButton'
import ColorProgressBar from 'components/CRM/UI/components/ColorProgressBar/ColorProgressBar'
import AddNewDeal from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/AddNewDeal/AddNewDeal'
import ProfileAvatar from 'components/CRM/UI/components/ProfileAvatar/ProfileAvatar'
import useWindowWidth from 'components/CRM/utils/hooks/useWindowWidth'
import MoveDeal from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/MoveDeal/MoveDeal'
import { ReactComponent as Message } from 'components/UI/icons/Message.svg'
import { ReactComponent as Phone } from 'components/CRM/UI/icons/phone-fill.svg'
import { ReactComponent as Chat } from 'components/CRM/UI/icons/Chat.svg'
import asideModalStore from 'Stores/asideModalStore'
import { superAxiosRequest } from 'axiosApi'
import swal from 'sweetalert'
import useLocalization from 'hooks/useLocalization'
import ReasonRejectModal from '../../Deals/DealsCard/ReasonRejectModal/ReasonRejectModal'
import RequiredFieldsConsultedModal from '../../Deals/DealsCard/RequiredFieldsPaidModal/RequiredFieldsConsultedModal'
import RequiredFieldsPaidModal from '../../Deals/DealsCard/RequiredFieldsConsultedModal/RequiredFieldsPaidModal'
import RequiredFieldsModal from '../../Deals/DealsCard/RequiredFieldsModal/RequiredFieldsModal'
import AddEditDeferredDeal from '../../Deals/DealsCard/AddEditDeferredDeal/AddEditDeferredDeal'
import { permissions } from 'settings/permissions'
import RequiredFieldsModalMeetings from '../../Deals/DealsCard/RequiredFieldsModalMeetings/RequiredFieldsModalMeetings'
import AddClient from './Modals/AddClient/AddClient'

const CustomerCard = ({
  setIsClose,
  isClose,
  dealData,
  setSelectedStatus,
  dealStatuses,
  selectedStatus,
  dealId,
  fetchDealData,
}) => {
  const history = useHistory()
  const windowWidth = useWindowWidth()
  const [statusHistory, setStatusHistory] = useState([])

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const funnelId = searchParams.get('funnel_id')

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'customer_card',
    dict: {
      responsible: 'Responsible',
      budget: 'Budget',
      city: 'City',
      branch: 'Branch',
      program: 'Program',
      level: 'Level',
      source: 'Source',
      call_status: 'Call status',
      oral_test_level: 'Oral test level',
      oral_test_teacher: 'Oral Test Teacher',
      rejection_reason: 'Rejection reason',
      deal_creation_date: 'Deal creation date',
      test: 'Test',

      client_link: 'Client link',
      printing: 'Printing',
      tag_management: 'Tag management',
      export_to_excel: 'Export to Excel',
      edit: 'Edit',
      delete: 'Delete',
      edit_contact: 'Edit contact',
      change_client: 'Change the client',
      go_to_card: 'Go to card',
      deal_movement: 'Deal movement',

      save: 'Save',
      edit_deal: 'Edit deal',
      move_deal: 'Moving a deal',
      are_you_sure: 'Are you sure',
      confirm_delete_deal: 'Are you sure you want to delete the deal',
      yes: 'Yes',
      no: 'No',

      planned_specialty: 'Какую специальность вы планируете выбрать',
      country: 'Страна',
      scores: 'Оценки',
      note: 'Примечание',
      meeting_format: 'Формат встречи',
      consultation_date: 'Время и дата консультации',
      program_selection: 'Выбор программ',
      year_of_study: 'Класс/Курс',
      birth_date: 'День рождения',
      institution: 'Школа/универ',
      comment: 'Комментарий',
      planned_admission_year: 'Планируемый год поступления',
      meeting_summary: 'Краткое описание встречи',
      specialty: 'Специальность',
      is_documents_received: 'Документы получены',
      country_of_admission: 'Страна поступления',
      institution_name: 'Название учебного заведения',
      partner_name: 'Название партнера',
      program_cost: 'Стоимость программы',
      posttraining_perspectives: 'Перспективы после обучения',
      client_annual_budget: 'Бюджет клиента на год',
      is_visa_required: 'Нужна виза',
      visa_appointment: 'Запись на визу',
      bonus_from: 'Бонус (указать имя от кого)',
      reminder_date: 'Напомнить о нас',
      flow: 'Поток',
      certificate: 'Сертификат',
      cover_letter: 'Сопроводительное письмо',
      heard_from: 'Откуда узнали',
    },
  })

  // Конфигурация колонок с их ID и обязательными полями
  const columnConfig = {
    69: {
      type: 'meeting_scheduled',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
        'meeting_format',
        'consultation_date',
      ],
      modalComponent: RequiredFieldsModalMeetings,
    },
    70: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    71: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    95: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    290: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        // 'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    291: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    292: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    334: {
      type: 'standard',
      requiredFields: ['reject_reason'],
      modalComponent: ReasonRejectModal,
    },
  }

  // Проверка является ли колонка специальной (требует валидации)
  const isSpecialColumn = (columnId) => {
    return columnConfig[columnId] !== undefined
  }

  // Получение типа колонки
  const getColumnType = (columnId) => {
    return columnConfig[columnId]?.type || null
  }

  // Получение обязательных полей для колонки
  const getRequiredFieldsForColumn = (columnId) => {
    return columnConfig[columnId]?.requiredFields || []
  }

  // Функции проверки обязательных полей для каждой колонки
  const hasRequiredFields = (deal, targetColumnId) => {
    const requiredFields = getRequiredFieldsForColumn(targetColumnId)

    if (requiredFields.length === 0) return true

    return requiredFields.every((field) => {
      const value = deal[field]
      return value !== undefined && value !== null && value !== ''
    })
  }

  // Функции открытия модальных окон для каждой колонки
  const openRequiredFieldsModal = (deal, targetColumnId) => {
    const config = columnConfig[targetColumnId]

    if (!config) return

    const ModalComponent = config.modalComponent
    const requiredFields = config.requiredFields

    // Создаем объект валидации для модалки
    const valid = {}
    requiredFields.forEach((field) => {
      valid[field] = 'required'
    })

    // Базовые данные для модалки
    const md = {
      deal_name: deal.deal_name,
      manager: deal.manager?.id,
      client: deal.client?.id || deal.lead?.client?.id,
      budget: deal.budget,
      city: deal.city?.id,
      branch: deal.branch?.id,
      program: deal.program?.id,
      source: deal.source,
      funnels: [funnelId],

      year_of_study: deal.year_of_study,
      level_result: deal.level_result,
      country: deal.country,
      country_of_admission: deal?.country_of_admission,
      planned_specialty: deal.planned_specialty,

      meeting_format: deal.meeting_format,
      consultation_date: deal.consultation_date,

      reject_reason: deal.reject_reason,
    }

    // Добавляем специфичные поля для разных типов
    if (config.type === 'paid') {
      md.is_application_signed = deal?.is_application_signed
      md.learning_type = deal?.learning_type
      md.education_type = deal?.education_type
      md.learning_goal = deal?.learning_goal
      md.learning_days = deal?.learning_days
    }

    const ms = {
      modalBodyComponent: () => <ModalComponent />,
      button: 'Save',
      link: `integration/deals/${deal.id}`,
      title: getModalTitle(targetColumnId),
      is_put: true,
      isResponsive: true,
      crm: true,
      onSubmitSuccess: (responseData) =>
        changeDealStatusAfterValidation(targetColumnId, responseData),
      valid: valid,
    }

    asideModalStore.activity(ms, md)
  }

  // Получение заголовка модалки в зависимости от колонки
  const getModalTitle = (columnId) => {
    const titles = {
      334: 'Добавить причину отказа',
      65: 'Заполните обязательные поля',
      13: 'Заполните информацию об обучении',
      69: 'Заполните данные для встречи',
      70: 'Заполните обязательные поля',
      71: 'Заполните обязательные поля',
      95: 'Заполните обязательные поля',
      290: 'Заполните обязательные поля',
      291: 'Заполните обязательные поля',
      292: 'Заполните обязательные поля',
    }
    return titles[columnId] || 'Заполните обязательные поля'
  }

  // Контекстное меню для контакта (клиента)
  const buildContactMenu = (isCombined) => {
    const base = [
      { name: translate.edit_contact, action: 'edit' },
      { name: translate.go_to_card, action: 'go_to_card' },
    ]

    if (isCombined) {
      base.push({
        name: 'Удалить из сделки',
        action: 'remove_from_deal',
        permission: permissions.delete_deals_crm,
      })
    }

    return base
  }

  // Контекстное меню для сделок
  const dealMenu = [
    { name: translate.client_link, action: 'link' },
    { name: translate.printing, action: 'printing' },
    { name: translate.deal_movement, action: 'moving' },
    { name: translate.tag_management, action: 'tag_management' },
    { name: translate.export_to_excel, action: 'export_to_excel' },
    { name: 'Отложить сделку', action: 'deferred_deal' },
    { name: translate.edit, action: 'edit' },
    {
      name: translate.delete,
      action: 'delete',
      permission: permissions.delete_deals_crm,
    },
  ]

  const renderClientCard = (client, options = {}) => {
    const {
      combinedDeal = null,
      showActionMenu = true,
      isCombined = false,
    } = options

    if (!client) return null

    const handleContactAction = (actionName) => {
      contactAction(actionName, client, combinedDeal)
    }

    return (
      <div
        key={client.id}
        className={`${styles.clientCard} ${styles.customerCardContainer} ${
          isCombined ? styles.combinedDealClient : ''
        }`}
      >
        <div className={styles.clientHeader}>
          <div className={styles.header}>
            <ProfileAvatar name={client?.name} />
            <div className={styles.name}>{client?.name}</div>
          </div>
          <div>
            {showActionMenu && (
              <ActionMenu
                menu={buildContactMenu(isCombined)}
                action={handleContactAction}
              />
            )}
          </div>
        </div>

        <div className={styles.clientInfo}>
          {client?.manager?.name && (
            <div className={styles.message}>
              <span>Manager: </span>
              {client?.manager?.name}
            </div>
          )}
          {client?.email && (
            <div className={styles.message}>
              <Message />
              <a href={`mailto:${client.email}`}>{client.email}</a>
            </div>
          )}
          {client?.whatsapp ? (
            <div className={styles.phone}>
              <Phone />
              <a href={`sip:${client.whatsapp}`}>{client.whatsapp}</a>
            </div>
          ) : client?.phone ? (
            <div className={styles.phone}>
              <Phone />
              <a href={`sip:${client.phone}`}>{client.phone}</a>
            </div>
          ) : null}
          {client?.additional_phone && (
            <div className={styles.phone}>
              <Phone />
              <a href={`sip:${client.additional_phone}`}>
                {client.additional_phone}
              </a>
            </div>
          )}
        </div>
      </div>
    )
  }

  const renderCombinedDealClient = (combinedDeal) => {
    const client = combinedDeal.client || combinedDeal.lead?.client
    return renderClientCard(client, {
      combinedDeal,
      showActionMenu: true,
      isCombined: true,
    })
  }

  const mainClientId = dealData?.client?.id || dealData?.lead?.client?.id

  const combinedDealsToShow =
    dealData?.combined_deals?.filter((combinedDeal) => {
      const combinedClient = combinedDeal.client || combinedDeal.lead?.client
      return combinedClient && combinedClient.id !== mainClientId
    }) || []

  useEffect(() => {
    const abortController = new AbortController()

    superAxiosRequest({
      link: `integration/deal_history/${dealId}`,
      method: 'get',
      crm: true,
      params: {
        funnel_id: +funnelId,
      },
      signal: abortController.signal,
    })
      .then((res) => {
        if (!abortController.signal.aborted) {
          setStatusHistory(res.data)
        }
      })
      .catch((err) => {
        console.error(err)
      })

    return () => abortController.abort()
  }, [dealData])

  // Фун-ция для изменения статуса сделки
  const changeDealStatus = (status_deal) => {
    const apiConf = {
      method: 'post',
      link: `integration/deals/${dealId}/change_status_deal`,
      crm: true,
    }
    const payload = {
      new_deal_status_id: status_deal,
      funnel_id: funnelId,
    }
    superAxiosRequest(apiConf, payload)
      .then(() => {
        fetchDealData()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  // Функция для изменения статуса после валидации
  const changeDealStatusAfterValidation = (status_deal, updatedData) => {
    // Если есть обновленные данные, сначала обновляем сделку
    if (updatedData) {
      const updateApiConf = {
        method: 'put',
        link: `integration/deals/${dealId}`,
        crm: true,
      }

      superAxiosRequest(updateApiConf, updatedData)
        .then(() => {
          // После обновления данных меняем статус
          changeDealStatus(status_deal)
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      // Если нет обновленных данных, просто меняем статус
      changeDealStatus(status_deal)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  /* ---------------------------------- <Menu and action> ----------------------------------*/
  // Обновление массива dealStatuses, добавление свойства action к каждому элементу
  const updatedArrDealStatuses = Object.values(dealStatuses)
    .map((status) => ({
      ...status,
      action: status.name.toLowerCase().replace(/ /g, '_'),
    }))
    .sort((a, b) => a.position - b.position)

  // Создание функции-обработчика действия для конкретного статуса с валидацией
  const createActionFunction = (status) => {
    return () => {
      // Проверяем, является ли целевой статус специальным (по ID)
      const isTargetSpecialColumn = isSpecialColumn(status.id)

      // Если перемещаем в специальную колонку, проверяем поля
      if (isTargetSpecialColumn && !hasRequiredFields(dealData, status.id)) {
        // Открываем соответствующее модальное окно
        openRequiredFieldsModal(dealData, status.id)
        return
      }

      // Если не в специальную колонку или все поля заполнены - меняем статус сразу
      changeDealStatus(status.id)
      setSelectedStatus(status.id)
    }
  }

  // Создание объекта actionFunctions, где ключи - имена действий, значения - соответствующие функции-обработчики
  const actionFunctions = {}
  updatedArrDealStatuses.forEach((status) => {
    const actionName = status.name.toLowerCase().replace(/ /g, '_')
    actionFunctions[actionName] = createActionFunction(status)
  })

  // Выполнение действия на основе имени действия, вызов соответствующей функции-обработчика
  const action = (actionName, e, items, line) => {
    const actionFunction = actionFunctions[actionName]
    if (actionFunction) {
      actionFunction()
    }
  }

  // Действия для сделок
  const dealAction = (action) => {
    switch (action) {
      case 'link':
        break
      case 'moving':
        movingDeal()
        break
      case 'printing':
        break
      case 'tag_management':
        tagManagement()
        break
      case 'export_to_excel':
        break
      case 'deferred_deal':
        deferredDeal()
        break
      case 'edit':
        editDealModal()
        break
      case 'delete':
        deleteDeal()
        break
      default:
        break
    }
  }

  // Действия для контакта (клиента)
  const contactAction = (action, client, combinedDeal = null) => {
    switch (action) {
      case 'edit':
        editContact(client)
        break
      case 'change':
        editDealModal()
        break
      case 'go_to_card':
        const name = client?.name
        const phone = client?.phone || client?.whatsapp
        const email = client?.email

        const params = new URLSearchParams()
        if (email) params.append('email', email)
        if (phone) params.append('phone', phone)
        if (name) params.append('name', name)

        const url = `/crm/clients-profiles?${params.toString()}`
        window.open(url, '_blank')
        break
      case 'remove_from_deal':
        removeClientFromDeal(client, combinedDeal)
        break
      default:
        break
    }
  }

  /* ---------------------------------- </Menu and action> ----------------------------------*/

  /* ---------------------------------- <Modals> ----------------------------------*/
  const removeClientFromDeal = (client, combinedDeal) => {
    if (!combinedDeal?.id) {
      swal({
        title: 'Ошибка',
        text: 'Не удалось определить связь клиента со сделкой',
        icon: 'error',
      })
      return
    }

    const clientName = client?.name || 'клиента'
    const dealName = dealData?.deal_name || ''

    swal({
      title: 'Удалить клиента из сделки?',
      text: `Удалить клиента ${clientName} из сделки "${dealName}"?`,
      icon: 'warning',
      buttons: {
        cancel: 'Отмена',
        confirm: {
          text: 'Удалить',
          value: true,
          visible: true,
          className: 'swal-button--danger',
        },
      },
      dangerMode: true,
    }).then((confirmed) => {
      if (!confirmed) return

      const apiConf = {
        method: 'delete',
        crm: true,
        link: `integration/deals/${combinedDeal?.id}`,
      }

      superAxiosRequest(apiConf)
        .then(() => {
          swal({
            title: 'Готово',
            text: 'Клиент удалён из сделки',
            icon: 'success',
            timer: 1500,
            buttons: false,
          }).then(() => {
            window.location.reload()
          })
        })
        .catch((error) => {
          console.error('Failed to remove client from deal', error)
          swal({
            title: 'Ошибка',
            text:
              error?.response?.data?.message ||
              'Не удалось удалить клиента из сделки. Попробуйте ещё раз.',
            icon: 'error',
          })
        })
    })
  }

  // Модалка для удаления сделки
  const deleteDeal = (data) => {
    swal({
      title: `${translate.are_you_sure}?`,
      text: `${translate.confirm_delete_deal}?`,
      icon: 'warning',
      buttons: [translate.no, translate.yes],
      dangerMode: true,
    }).then((yes) => {
      if (yes) {
        const apiConf = {
          method: 'delete',
          crm: true,
          link: `integration/deals/${dealId}`,
        }
        superAxiosRequest(apiConf, { is_active: false }).then(() => {
          history.push(`/crm/deals/?funnel_id=${funnelId}`)
        })
      }
    })
  }

  // Модалка для редактирования телефона и почты клиента
  const editContact = (client) => {
    const clientId = client?.id
    const ms = {
      modalBodyComponent: () => <AddContact />,
      button: translate.save,
      link: `integration/clients/${clientId}`,
      title: translate.edit_contact,
      isCenter: true,
      crm: true,
      is_put: true,
      onSubmitSuccess: () => fetchDealData(),
      valid: {
        phone: 'required',
      },
    }

    const md = { ...client, manager: client?.manager?.id }
    asideModalStore.activity(ms, md)
  }

  // Модалка для редактирования данных сделки
  const editDealModal = () => {
    const ms = {
      modalBodyComponent: () => (
        <AddNewDeal isEdit dealId={dealId} funnelId={funnelId} />
      ),
      button: translate.save,
      link: `integration/deals/${dealId}`,
      title: translate.edit_deal,
      is_put: true,
      isResponsive: true,
      crm: true,
      onSubmitSuccess: () => {
        fetchDealData()
      },
      valid: {},
    }
    asideModalStore.activity(ms, {
      deal_name: dealData?.deal_name,
      manager: dealData?.manager?.id,
      client: dealData?.client?.id || dealData?.lead?.client?.id,
      client_name: dealData?.client?.name || dealData?.lead?.client?.name,
      client_text_name: dealData?.client_text_name,
      budget: dealData?.budget,
      city: dealData?.city?.id,
      branch: dealData?.branch?.id,
      program: dealData?.program?.id,
      level_result: dealData?.level_result,
      status_deal: dealData?.status_deal?.id,
      note: dealData?.note,
      reject_reason: dealData?.reject_reason,
      learning_type: dealData?.learning_type,
      education_type: dealData?.education_type,
      learning_goal: dealData?.learning_goal,
      learning_days: dealData?.learning_days,
      source: dealData?.source,
      funnels: [funnelId],

      planned_specialty: dealData?.planned_specialty,
      country: dealData?.country,
      scores: dealData?.scores,
      meeting_format: dealData?.meeting_format,
      consultation_date: dealData?.consultation_date,
      program_selection: dealData?.program_selection,
      year_of_study: dealData?.year_of_study,
      birth_date: dealData?.birth_date,
      institution: dealData?.institution,
      comment: dealData?.comment,
      planned_admission_year: dealData?.planned_admission_year,
      meeting_summary: dealData?.meeting_summary,
      specialty: dealData?.specialty,
      is_documents_received: dealData?.is_documents_received,
      country_of_admission: dealData?.country_of_admission,
      institution_name: dealData?.institution_name,
      partner_name: dealData?.partner_name,
      program_cost: dealData?.program_cost,
      posttraining_perspectives: dealData?.posttraining_perspectives,
      client_annual_budget: dealData?.client_annual_budget,
      is_visa_required: dealData?.is_visa_required,
      visa_appointment: dealData?.visa_appointment,
      bonus_from: dealData?.bonus_from,
      reminder_date: dealData?.reminder_date,
      flow: dealData?.flow,
      certificate: dealData?.certificate,
      cover_letter: dealData?.cover_letter,
      heard_from: dealData?.heard_from,
      age: dealData?.age,
    })
  }

  // Модалка для перемещения сделки в другие воронки
  const movingDeal = () => {
    const funnelIds = dealData?.funnels?.map((funnel) => funnel.id)

    const ms = {
      modalBodyComponent: () => (
        <MoveDeal dealId={dealId} funnelId={funnelId} />
      ),
      button: translate.save,
      link: `integration/deals/${dealId}`,
      title: translate.move_deal,
      is_put: true,
      isResponsive: true,
      crm: true,
      onSubmitSuccess: () => fetchDealData(),
      valid: {
        funnels: 'required',
      },
    }

    asideModalStore.activity(ms, {
      deal_name: dealData?.deal_name,
      manager: dealData?.manager?.id,
      client: dealData?.client?.id,
      budget: dealData?.budget,
      city: dealData?.city?.id,
      branch: dealData?.branch?.id,
      program: dealData?.program?.id,
      level_result: dealData?.level_result,
      status_deal: dealData?.status_deal?.id,
      note: dealData?.note,
      funnels: funnelIds,
    })
  }

  // Модалка для добавления тегов
  const deferredDeal = () => {
    const ms = {
      modalBodyComponent: () => <AddEditDeferredDeal />,
      button: 'Сохранить',
      link: `integration/deferred_deals`,
      title: 'Отложить сделку',
      isResponsive: true,
      crm: true,
      onBeforeSubmit: (data) => {
        const deferredDays = data?.deferred_until

        let deferredDate = null

        if (
          deferredDays !== null &&
          deferredDays !== undefined &&
          deferredDays !== ''
        ) {
          const today = new Date()

          const futureDate = new Date(today)
          futureDate.setDate(today.getDate() + Number(deferredDays))

          const year = futureDate.getFullYear()
          const month = String(futureDate.getMonth() + 1).padStart(2, '0')
          const day = String(futureDate.getDate()).padStart(2, '0')

          deferredDate = `${year}-${month}-${day}`
        }

        return {
          ...data,
          deferred_until: deferredDate,
        }
      },
      valid: {
        deferred_until: 'required',
      },
    }
    asideModalStore.activity(ms, {
      deal: dealId,
      funnel: funnelId,
    })
  }

  // Модалка для добавления тегов
  const tagManagement = () => {
    const tagIds = dealData?.tags?.map((tag) => tag.id)
    const funnelIds = dealData?.funnels?.map((funnel) => funnel.id)

    const ms = {
      modalBodyComponent: () => <TagManagement />,
      button: translate.save,
      link: `integration/deals/${dealId}`,
      is_put: true,
      title: translate.tag_management,
      isResponsive: true,
      crm: true,

      onSubmitSuccess: () => {
        fetchDealData()
      },
      valid: {
        tags: 'required',
      },
    }

    asideModalStore.activity(ms, { tags: tagIds, funnels: funnelIds })
  }

  const onBeforeSubmitClient = (data) => {
    const {
      phone,
      whatsapp,
      inn,
      instagram,
      telegram,
      level_result,
      comment,
      client_id,
      ...rest
    } = data

    if (client_id) {
      return {
        deal_id: dealId,
        client_id: Number(client_id),
        funnel_id: funnelId,
      }
    }

    return {
      deal_id: dealId,
      client: {
        ...rest,
        ...(phone && { phone: String(phone).replace(/^\+/, '') }),
        ...(whatsapp && {
          whatsapp: String(whatsapp).startsWith('+')
            ? whatsapp
            : `+${whatsapp}`,
        }),
        ...(inn && { inn: String(inn) }),
        ...(instagram && { instagram: String(instagram) }),
        ...(telegram && { telegram: String(telegram) }),
        ...(level_result && { level_result: String(level_result) }),
        ...(comment && { comment: String(comment) }),
      },
      funnel_id: funnelId,
    }
  }

  const addClient = () => {
    const ms = {
      modalBodyComponent: () => <AddClient showClientTypeToggle={true} />,
      button: 'Добавить',
      link: 'integration/create_client_deal',
      crm: true,
      title: 'Добавить клиента',
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchDealData()
      },
      valid: {},
    }
    const md = { funnel_id: funnelId }
    asideModalStore.activity(ms, md)
  }

  /* ---------------------------------- </Modals> ----------------------------------*/

  const currentDealStatusName = updatedArrDealStatuses?.find(
    (el) => el.id === selectedStatus,
  )?.name
  const currentFunnelName = dealData?.funnels?.filter(
    (f) => f.id === +funnelId,
  )[0]?.name

  return (
    <div
      className={`${styles.container} ${isClose.card && windowWidth <= 768 ? styles.closeCard : ''}`}
    >
      <div className={styles.customerCardContainer}>
        <div className={styles.customerCardHeader}>
          <div className={styles.backButtonContainer}>
            <BackButton link={`/crm/deals/?funnel_id=${funnelId}`} />
            <div className={styles.numberOfDealBlock} onClick={editDealModal}>
              <div>#{dealData?.deal_name}</div>
            </div>
          </div>
          <ActionMenu menu={dealMenu} action={dealAction} />
        </div>
        <div className={styles.tagsBlock}>
          {dealData?.tags?.map((tag) => (
            <span key={tag.id} className={styles.tag}>
              {tag.name}
            </span>
          ))}
          <div onClick={tagManagement} className={styles.addTagButton}>
            + Добавить тег
          </div>
        </div>
        <div className={styles.companyName}>{currentFunnelName}</div>
        <div className={styles.statusHeader}>
          <div className={styles.statusName}>{currentDealStatusName}</div>
          <ActionMenu
            iconType={'arrow'}
            menu={updatedArrDealStatuses}
            action={action}
          />
        </div>
        <div className={styles.colorProgressBar}>
          <ColorProgressBar
            selectedStatusId={selectedStatus}
            statuses={updatedArrDealStatuses}
            statusHistory={statusHistory}
          />
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.infoBlock}>
            <div className={styles.valueBlock}>
              <div className={`${styles.name}`}>{translate.responsible}</div>
              <div className={styles.value} onClick={editDealModal}>
                {dealData?.manager?.full_name || 'Select manager'}
              </div>
            </div>
            <div className={styles.valueBlock}>
              <div className={`${styles.name}`}>{translate.budget}</div>
              <div className={`${styles.editBudgetBlock} ${styles.value}`}>
                <div
                  className={`${styles.editBudgetBlock} ${styles.value}`}
                  onClick={editDealModal}
                >
                  <div>{dealData?.budget} ₸</div>
                </div>
              </div>
            </div>
            <div className={styles.valueBlock}>
              <div className={`${styles.name}`}>{translate.city}</div>
              <div className={styles.value} onClick={editDealModal}>
                {dealData?.city?.name || 'Select city'}
              </div>
            </div>
            <div className={styles.valueBlock}>
              <div className={`${styles.name}`}>{translate.branch}</div>
              <div className={styles.value} onClick={editDealModal}>
                {dealData?.branch?.name || 'Select branch'}
              </div>
            </div>
            <div className={styles.valueBlock}>
              <div className={`${styles.name}`}>{translate.program}</div>
              <div className={styles.value} onClick={editDealModal}>
                {dealData?.program?.name || 'Select program'}
              </div>
            </div>
            <div className={styles.valueBlock}>
              <div className={`${styles.name}`}>{'Уровень английского'}</div>
              <div className={styles.value} onClick={editDealModal}>
                {dealData?.level_result || 'Select level'}
              </div>
            </div>
            {/*<div className={styles.valueBlock}>*/}
            {/*  <div className={styles.name}>{translate.source}</div>*/}
            {/*  <div className={styles.value}>*/}
            {/*    {dealData?.lead?.source?.name || 'API'}*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div className={styles.valueBlock}>
              <div className={styles.name}>{translate.call_status}</div>
              <div className={styles.value}>API</div>
            </div>
            {dealData?.oral_test_level && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>Placement test</div>
                <div className={styles.value}>{dealData?.oral_test_level}</div>
              </div>
            )}
            {dealData?.training_level && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.oral_test_teacher}</div>
                <div className={styles.value}>{dealData?.training_level}</div>
              </div>
            )}

            {dealData?.training_level && dealData?.slot_comment && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>Teacher comment</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.slot_comment}
                </div>
              </div>
            )}

            {dealData?.reject_reason && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.rejection_reason}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData?.reject_reason}
                </div>
              </div>
            )}

            {dealData?.learning_type && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>Вид обучения</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData?.learning_type}
                </div>
              </div>
            )}

            {dealData?.education_type && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>Тип обучения</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData?.education_type}
                </div>
              </div>
            )}

            {dealData?.learning_goal && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>Цель обучения</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData?.learning_goal}
                </div>
              </div>
            )}

            {dealData?.learning_days && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>Дни обучения</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData?.learning_days}
                </div>
              </div>
            )}

            {dealData?.source && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>Откуда пришли</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData?.source}
                </div>
              </div>
            )}

            <div className={styles.valueBlock}>
              <div className={styles.name}>{translate.deal_creation_date}</div>
              <div className={styles.value}>
                {new Date(dealData?.created_at).toLocaleDateString()}
              </div>
            </div>

            {dealData?.planned_specialty && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.planned_specialty}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.planned_specialty}
                </div>
              </div>
            )}
            {dealData?.country && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.country}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.country}
                </div>
              </div>
            )}
            {dealData?.scores && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.scores}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.scores}
                </div>
              </div>
            )}
            {dealData?.note && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.note}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.note}
                </div>
              </div>
            )}
            {dealData?.meeting_format && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.meeting_format}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.meeting_format}
                </div>
              </div>
            )}
            {dealData?.consultation_date && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.consultation_date}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {new Date(dealData.consultation_date).toLocaleString('ru-RU')}
                </div>
              </div>
            )}
            {dealData?.program_selection && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.program_selection}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.program_selection}
                </div>
              </div>
            )}
            {dealData?.year_of_study && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.year_of_study}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.year_of_study}
                </div>
              </div>
            )}
            {dealData?.birth_date && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.birth_date}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {new Date(dealData.birth_date).toLocaleDateString('ru-RU')}
                </div>
              </div>
            )}
            {dealData?.institution && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.institution}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.institution}
                </div>
              </div>
            )}
            {dealData?.comment && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.comment}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.comment}
                </div>
              </div>
            )}
            {dealData?.planned_admission_year && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>
                  {translate.planned_admission_year}
                </div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.planned_admission_year}
                </div>
              </div>
            )}
            {/*{dealData?.meeting_summary && (*/}
            {/*  <div className={styles.valueBlock}>*/}
            {/*    <div className={styles.name}>{translate.meeting_summary}</div>*/}
            {/*    <div className={styles.value} onClick={editDealModal}>*/}
            {/*      {dealData.meeting_summary}*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*)}*/}
            {dealData?.specialty && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.specialty}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.specialty}
                </div>
              </div>
            )}
            {typeof dealData?.is_documents_received === 'boolean' && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>
                  {translate.is_documents_received}
                </div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.is_documents_received ? 'Да' : 'Нет'}
                </div>
              </div>
            )}
            {dealData?.country_of_admission && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>
                  {translate.country_of_admission}
                </div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.country_of_admission}
                </div>
              </div>
            )}
            {dealData?.institution_name && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.institution_name}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.institution_name}
                </div>
              </div>
            )}
            {dealData?.partner_name && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.partner_name}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.partner_name}
                </div>
              </div>
            )}
            {dealData?.program_cost && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.program_cost}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.program_cost}
                </div>
              </div>
            )}
            {dealData?.posttraining_perspectives && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>
                  {translate.posttraining_perspectives}
                </div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.posttraining_perspectives}
                </div>
              </div>
            )}
            {dealData?.client_annual_budget && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>
                  {translate.client_annual_budget}
                </div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.client_annual_budget}
                </div>
              </div>
            )}
            {typeof dealData?.is_visa_required === 'boolean' && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.is_visa_required}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.is_visa_required ? 'Да' : 'Нет'}
                </div>
              </div>
            )}
            {dealData?.visa_appointment && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.visa_appointment}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.visa_appointment}
                </div>
              </div>
            )}
            {dealData?.bonus_from && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.bonus_from}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.bonus_from}
                </div>
              </div>
            )}
            {dealData?.reminder_date && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.reminder_date}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {new Date(dealData.reminder_date).toLocaleDateString('ru-RU')}
                </div>
              </div>
            )}
            {dealData?.flow && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.flow}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.flow}
                </div>
              </div>
            )}
            {typeof dealData?.certificate === 'boolean' && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.certificate}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.certificate ? 'Да' : 'Нет'}
                </div>
              </div>
            )}
            {typeof dealData?.cover_letter === 'boolean' && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.cover_letter}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.cover_letter ? 'Да' : 'Нет'}
                </div>
              </div>
            )}
            {dealData?.heard_from && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>{translate.heard_from}</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.heard_from}
                </div>
              </div>
            )}
            {dealData?.age && (
              <div className={styles.valueBlock}>
                <div className={styles.name}>Age</div>
                <div className={styles.value} onClick={editDealModal}>
                  {dealData.age}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <>
        {/* Рендерим основного клиента */}
        {dealData.client &&
          renderClientCard(dealData.client, { showActionMenu: true })}
        {dealData.lead &&
          !dealData?.client &&
          renderClientCard(dealData.lead.client, { showActionMenu: true })}

        {/* Рендерим клиентов из объединенных сделок */}
        {combinedDealsToShow.length > 0 && (
          <div className={styles.combinedDealsSection}>
            {combinedDealsToShow.map(renderCombinedDealClient)}
          </div>
        )}

        <button className={styles.btnAdd} onClick={addClient}>
          Добавить клиента
        </button>
      </>

      <div className={styles.addContactBtn}>
        {windowWidth < 768 && (
          <button
            className={styles.openChatBtn}
            onClick={() => {
              setIsClose({ chat: true, card: true })
              scrollToTop()
            }}
          >
            <Chat /> Open chat
          </button>
        )}
      </div>
    </div>
  )
}

export default CustomerCard
